
import { SaleService } from "@/services/sale-service";
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";
import { AuthService } from "@/services/auth-service";
import AppMissingModuleModal from "@/components/common/MissingModuleModal.vue";
import { SaleLayoutInfo } from "@/utils/sale-layouts/sale-layout-info";
import AppSaleLayoutList from "@/components/settings-sales/SaleLayoutList.vue";
import { TranslateResult } from "vue-i18n";
import { ElectronFunctions } from "@/utils/electron/electron";
import { BrowserInfo } from "@/utils/browser";
import { UserConfigService } from "@/services/user-config-service";
import { IElectronPrinter } from "@/utils/electron/electron-printer";

export default Vue.extend({
	data() {
		return {
			layouts: [] as SaleLayoutInfo[],
			missingModule: false,
			printers: [] as IElectronPrinter[],
			userConf: UserConfigService.getSaleSettings()
		};
	},
	props: {

	},
	computed: {
		path():IBreadCrumb[] {
			return [
				{
					to: "/settings/sales", value: this.$ct("sale").toString()
				},
				{
					value: this.$ct("sale-layouts").toString()
				}
			];
		},
		visibleLayouts():SaleLayoutInfo[] {
			let allLayouts = this.layouts;
			if (!AuthService.isDevModeEnabled){
				allLayouts = allLayouts.filter(l=>l.OnlyEditableBySupport == false);
			}
			return allLayouts;
		},
		clientLayouts():SaleLayoutInfo[] {
			return this.visibleLayouts.filter(l=>l.ContactGroupID == 1);
		},
		supplierLayouts():SaleLayoutInfo[] {
			return this.visibleLayouts.filter(l=>l.ContactGroupID == 2);
		},
		clientsTitle():TranslateResult{
			return this.$ct("common.browse.Sales");
		},
		suppliersTitle():TranslateResult {
			return this.$ct("common.browse.BestelbonLeveranciers");
		},
	},
	methods: {
		async fetch() {
			this.layouts = (await SaleService.getSaleLayouts());
		},
		async deleteLayout(layout:SaleLayoutInfo){
			let confirm = await this.$confirmBuilder().setWarningTitle().setMessage(this.$ct("are-you-sure-you-want-to-remove-layout", {name: layout.Name})).show();
			if (!confirm) return;
			await SaleService.deleteSaleLayout(layout);
			await this.fetch();
		},
		getLayoutCopyName(layout:SaleLayoutInfo):string {
			let layoutList = this.clientLayouts;
			if (this.supplierLayouts.indexOf(layout) != -1) {
				layoutList = this.supplierLayouts;
			}

			let baseName = `${layout.Name} ${this.$ct("common.copy-noun")} `;
			let newName = baseName;

			for (let i = 1; i < 100; i++) {
				newName = `${baseName} ${i}`;
				let found = false;
				for (let layout of layoutList) {
					if (layout.Name == newName){
						found = true;
						break;
					}
				}
				if (!found) {
					break;
				}
			}
			return newName;
		},
		async copyLayout(layout:SaleLayoutInfo){
			if (!AuthService.hasModule(13)) {
				this.missingModule = true;
				return;
			}

			let fetchedLayout = await SaleService.getSaleLayout(layout.ID);
			fetchedLayout.ID = 0;
			fetchedLayout.Name = this.getLayoutCopyName(layout);
			await SaleService.postSaleLayouts([fetchedLayout]);
			await this.fetch();
		},
		async saveSaleOrder(order:number[]){
			let conf = UserConfigService.getSaleSettings();
			conf.SaleLayoutDisplayOrder = order;
			await UserConfigService.setSaleSettings(conf);
		},
		async savePurchaseOrder(order:number[]){
			let conf = UserConfigService.getSaleSettings();
			conf.PurchaseLayoutDisplayOrder = order;
			await UserConfigService.setSaleSettings(conf);
		},
	},
	async mounted() {
		await this.fetch();
		if (BrowserInfo.hasElectronConfigured()){
			this.printers = await ElectronFunctions.getPrinters();
		}
	},
	components: {
		AppMissingModuleModal,
		AppSaleLayoutList
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
